module.exports = __webpack_public_path__ + "img/brink2-cover.daccd290.jpg";